import React, { Component } from "react";
import {
  Row,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Col,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";

import "./Items.scss";
import DefaultImg from "../../assets/images/product/Default_img.jpg";

import {
  getAllProducts,
  modelListOpen,
  modelListClose,
} from "../../store/MaterialRequest/actions";

class ListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      item_details: [],
    };

    this.toggleTab = this.toggleTab.bind(this);
  }

  toggleTab(tab, product) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
          item_details: product,
        });
      }
    }
  }


  componentDidUpdate(prevProps) {
   
    console.log("MR ItemsRow Data:", this.props.mrItemsList);
  
}
  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.listModel}
          backdrop="static"
          centered
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              this.props.modelListClose();
              this.toggleTab(1, null);
            }}
          >
            List Item
          </ModalHeader>
          <ModalBody className="pt-0">
            <Row className="justify-content-center">
              <Col md={12}>
                <Row>
                  <Col lg={12}>
                    <Nav tabs className="nav-tabs-custom ">
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(1, null);
                          }}
                          className={classnames(
                            { active: this.state.activeTab === 1 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Items List |{" "}
                          <span>{this.props.mrItemsList.length}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: this.state.activeTab === 2 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          {this.state.activeTab === 2 && "Details"}
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId={1}>
                        <div className="table-responsive">
                          <Table
                            striped
                            bordered
                            hover
                            className="table-centered mb-0"
                          >
                            <thead className="bg-light ">
                              <tr>
                                <th>Item Images</th>
                                <th style={{ minWidth: "220px" }}>Item Name</th>
                                <th>Quantity</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.mrItemsList?.map((product, key) => (
                                <tr key={key}>
                                  <td>
                                    <img
                                      src={
                                        // // product.product.image == null
                                        // //   ? DefaultImg
                                        // //   : product.product.image
                                        // product[0]?.image
                                        // ? product[0].image
                                        // : DefaultImg
                                        product?.mritemimages?.[0]?.image
                                        ? product.mritemimages[0].image
                                        : DefaultImg
                                      }
                                      alt="product-img"
                                      title="product-img"
                                      className="avatar-sm"
                                    />
                                  </td>
                                  <td style={{ width: "33%" }}>
                                    <h5 className="font-size-14 text-truncate">
                                      <Link
                                        to="#"
                                        className="text-dark"
                                        onClick={() => {
                                          this.toggleTab(2, product);
                                        }}
                                      >
                                        {product.product.name}
                                      </Link>
                                    </h5>
                                    <p className="mb-0">
                                      Description :{" "}
                                      <span className="">
                                        {product.description}
                                      </span>
                                    </p>
                                  </td>
                                  <td>
                                    {product.qty} {product.unit?.name}
                                  </td>

                                  <td>
                                    <Button
                                      type="sudmit"
                                      color="primary"
                                      className="waves-effect waves-light mr-2"
                                      onClick={() => {
                                        this.toggleTab(2, product);
                                      }}
                                    >
                                      <i className="mdi mdi-arrow-top-right mr-2"></i>
                                      View
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </TabPane>
                      <TabPane tabId={2}>
                        <Row>
                          <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                            <div className="product-detail">
                              <img
                                src={
                                  this.state.item_details?.product?.image ==
                                  null
                                    ? DefaultImg
                                    : this.state.item_details?.product?.image
                                }
                                alt="product-img"
                                title="product-img"
                                className=" product-img img-fluid mx-auto tab-img rounded"
                              />
                            </div>
                          </Col>
                          <Col xs={12} sm={12} md={7} lg={7} xl={7}>
                            <div className="mt-4 mt-xl-3">
                              <div className="float-right ">
                                <Button
                                  type="button"
                                  color="primary"
                                  className="waves-effect waves-light d-inline-block mr-2"
                                  onClick={() => {
                                    this.toggleTab(1, null);
                                  }}
                                >
                                  <i className="mdi mdi-backup-restore mr-1"></i>
                                  Back
                                </Button>
                              </div>
                              <div>
                                <h5 className="mt-1 mb-1">
                                  {this.state.item_details?.product?.name}
                                </h5>
                                <div>
                                  <p className="d-inline-block">
                                    {this.state.item_details?.product?.code ===
                                    "nan"
                                      ? "-"
                                      : this.state.item_details?.product?.code}
                                  </p>
                                </div>
                              </div>
                              <hr className="my-1" />

                              <Row>
                                <Col md={12}>
                                  <div className="Order-panel-content">
                                    <h5 className="font-size-14">
                                      Specification :
                                    </h5>
                                    <div className="list-column">
                                      <ul className="list-style-two p-0 product-desc-list">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Quantity :
                                          </span>
                                          <span className="dtl">
                                            {this.state.item_details?.qty}{" "}
                                            {
                                              this.state.item_details?.unit
                                                ?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Section :
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.state.item_details?.product
                                                ?.section?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Required Date:
                                          </span>
                                          <span className="dtl">
                                            {this.state.item_details?.date}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Item Unit :
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.state.item_details?.product
                                                ?.baseunit?.name
                                            }
                                          </span>
                                        </li>

                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Department :
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.state.item_details?.product
                                                ?.department?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Category :
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.state.item_details?.product
                                                ?.category?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Product Group :
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.state.item_details?.product
                                                ?.group?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Make :
                                          </span>
                                          <span className="dtl">
                                            {this.state.item_details?.make}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Description :
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.state.item_details
                                                ?.description
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            <i className="mdi mdi-circle-medium mr-1 align-middle"></i>
                                            Specification :
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.state.item_details?.product
                                                ?.description
                                            }
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </Col>
            </Row>

            <ModalFooter>
              <div className="float-right">
                <Button
                  type="button"
                  color="light"
                  className="waves-effect waves-light"
                  onClick={() => {
                    this.toggleTab(1, null);
                    this.props.modelListClose();
                  }}
                >
                  Close
                </Button>
              </div>
            </ModalFooter>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { mrItemsList, listModel, locId, deptId, reqrowdata } =
    state.Materialrequest;
  return { mrItemsList, listModel, locId, deptId, reqrowdata };
};

export default connect(mapStatetoProps, {
  getAllProducts,
  modelListOpen,
  modelListClose,
})(ListItem);
